import { Selector, createSelector } from 'reselect';
import { ReduxState } from '../../../ReduxStorage/state';
import { LearnersEmailConsentState, INITIAL_STATE } from './state';

export const LearnersEmailConsentSelector = (
  state: ReduxState
): LearnersEmailConsentState => state.LearnersEmailConsent || INITIAL_STATE;

export const selectCurrentLearnerHasEnrolmentConsentPermission: Selector<
  ReduxState,
  boolean
> = createSelector(
  [LearnersEmailConsentSelector],
  (learnersEmailConsent) => learnersEmailConsent.hasEnrolmentConsentPermission
);

export const selectUpdateHasEnrolmentConsentPermissionError: Selector<
  ReduxState,
  string | null
> = createSelector(
  [LearnersEmailConsentSelector],
  (learnersEmailConsent) =>
    learnersEmailConsent.updateHasEnrolmentConsentPermissionError
);
